<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'pieChartsInfeed',
        props: {
            'pieData': Array
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    legend: {},
                    series: {}
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            // echarts.registerMap('yunnan', JSON);
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        computed: {
        },
        watch: {
            pieData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            getXaxisData () {
                // 填入横轴数据
                if (this.pieData.length > 0) {
                    return this.pieData.map(item => {
                        return item.name
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                return this.pieData
            },
            getTotal () {
                var total = 0;
                var data = this.getSeriesData()
                for (var i = 0, l = data.length; i < l; i++) {
                    total += data[i].value;
                }
                return total
            },
            setSeriesData () {
                this.setOptions('legend', (() => {
                    let that = this
                    return {
                        orient: 'vertical',
                        selectedMode: false,
                        right: '15%',
                        itemWidth: 10,
                        itemHeight: 10,
                        top: '23%',
                        bottom: '10%',
                        // padding: 40,
                        itemGap: 10,
                        data: that.getXaxisData(),
                        textStyle: {
                            fontSize: 10
                        },
                        formatter: function (name) {
                            var total = 0;
                            var target;
                            var data = that.getSeriesData()
                            for (var i = 0, l = data.length; i < l; i++) {
                                total += data[i].value;
                                if (data[i].name === name) {
                                    target = data[i].value;
                                }
                            }
                            return name + '\n\n ' + ((target / total) * 100).toFixed(2) + '%' + '       ' + target + '条';
                        }
                    }
                })());
                this.setOptions('title', (() => {
                    let that = this
                    return {
                        show: true,
                        text: that.getTotal(),
                        subtext: '总数（家）',
                        textStyle: {
                            color: 'rgba(51,51,51,1)',
                            fontSize: 24,
                            align: 'center'
                        },
                        subtextStyle: {
                            show: that.getTotal() > 0,
                            fontSize: 14,
                            color: 'rgba(51,51,51,1)',
                            align: 'right'
                        },
                        x: '20%',
                        y: '42%'
                    }
                })());
                this.setOptions('series', (() => {
                    let that = this
                    return {
                        type: 'pie',
                        center: ['30%', '50%'],
                        radius: ['50%', '60%'],
                        avoidLabelOverlap: false,
                        hoverAnimation: false,
                        silent: true,
                        label: {
                            normal: {
                                show: false
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: function (params) {
                                    // 自定义颜色
                                    var colorList = [
                                        '#36B374', '#FF8C19', '#FF4D4D'
                                    ];
                                    return colorList[params.dataIndex]
                                }
                            }
                        },
                        data: that.getSeriesData()
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
}
</style>
